import loadable from "@loadable/component";

export default loadable(() => import("./Lightbox"), {
  resolveComponent: (component) => component.default,
  ssr: false,
});
